import React from 'react'
import MadeWithLove from 'react-made-with-love';
export default function Footer() {
  return (
    <div>
      <MadeWithLove

  emoji
  by="Kaushik S"
  link="https://www.linkedin.com/in/kaushik-ss/"
/>
and
<a href="https://www.linkedin.com/in/navin-praanav-62088323b/"> Navin Praanav P</a>


    </div>
  )
}
